module.exports = __webpack_public_path__ + "static/media/sell_help_2b.53019065.png";